module.exports = __webpack_public_path__ + "static/arctic-glacier-logo-2453917fb481e86e4fdab2336dca493d.jpeg";